import React, { useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import IntroductionPage from "./components/Intro/IntroductionPage";

import HomePage from "./components/Home/HomePage";

const App = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if(!localStorage.getItem('skippedIntro') && !localStorage.getItem('userName')) {
      navigate('/name_creation')
    }

    if(localStorage.getItem('language')) {
      document.documentElement.setAttribute("lang", localStorage.getItem('language'));
    }

    if(localStorage.getItem('theme')) {
      switch(localStorage.getItem('theme')) {
        case 'dark':
          document.body.style.backgroundColor = '#232323';
          break;
        case 'light':
          document.body.style.backgroundColor = 'rgb(235, 234, 232)';
          break;
        default:
          document.body.style.backgroundColor = 'rgb(235, 234, 232)';
      }
    }
  }, [])

  return <>
    <Routes>
      <Route path='/name_creation' element={ <IntroductionPage />}></Route>
      <Route path="/" element={<HomePage />} />
    </Routes>
  </>
}

export default App;